import { Button } from '@material-ui/core';
import GitHubIcon from '@material-ui/icons/GitHub';
import StorageIcon from '@material-ui/icons/Storage';
import React, { useEffect, useState } from 'react';

import { Col, Cols, spacing, Text } from '~/src/dash/publicaUI';
import { getApiDomain, getPrInfo } from '~/src/dash/resellers/utils/importResellerConfig';
import { publicaColors } from '~/src/dash/utils/colors';

const formatPrTitle = (title: string): string => {
  if (title.length >= 2 && title[0] === '"' && title[title.length - 1] === '"') {
    return title.slice(1, title.length - 1);
  }
  return title;
};

interface IVersionz {
  version: string;
  env: string;
}

let getVersionPr: Promise<IVersionz>;
const getVersion = (): Promise<IVersionz> => {
  if (!getVersionPr) {
    getVersionPr = fetch(getApiDomain() + '/versionz').then((resp) => {
      return resp.json();
    });
  }
  return getVersionPr;
};

// TODO: AFTER TESTING IS SUCCESSFUL, DEPRECATE components/debug-topbar.tsx
// IMPORTANT: This is just a quick refactor of components/debug-topbar.tsx and retains much of the same code and functionality/lack thereof.
// The non-functioning pieces should be investigated later.

export const DebugBanner = () => {
  const [versionz, setVersionz] = useState('');
  const prInfo = getPrInfo(); // this currently does not work as intended.

  useEffect(() => {
    getVersion().then((o: IVersionz) => {
      setVersionz(o.version);
    });
  }, []);

  return (
    <Cols
      horizontalPadding
      extraSmallVerticalPadding
      marginBottom={spacing.small}
      gap={spacing.base}
      style={{
        backgroundColor: publicaColors.orange,
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: '6px',
      }}
    >
      {/* LEFT SIDE */}
      <Col flex>
        <Cols gap={spacing.small} style={{ alignItems: 'center' }}>
          <Col displayFlex>
            <StorageIcon />
          </Col>
          <Col>
            <Text small bold color={publicaColors.black}>{`API: ${versionz}`}</Text>
          </Col>
          {/* prInfo CURRENTLY DOES NOT WORK IN PROD */}
          <Col>
            <Text small>{prInfo.pr_owner || ''}</Text>
          </Col>
          <Col>
            <Text small>{formatPrTitle(prInfo.pr_title || '')}</Text>
          </Col>
        </Cols>
      </Col>
      {/* RIGHT SIDE */}
      <Col>
        <Cols gap={spacing.small} style={{ alignItems: 'center' }}>
          <Col>
            <a href={prInfo.pr_url || ''}>
              <Button style={{ width: '100%' }}>
                <Cols gap={spacing.small} style={{ alignItems: 'center' }}>
                  <Col>
                    <Text small bold color={publicaColors.black}>
                      Github
                    </Text>
                  </Col>
                  <Col displayFlex>
                    <GitHubIcon />
                  </Col>
                </Cols>
              </Button>
            </a>
          </Col>
          <Col>
            <a href={`https://publica-project.atlassian.net/browse/${prInfo.pr_branch || ''}`}>
              <Button style={{ width: '100%' }}>
                <Cols gap={spacing.small} style={{ alignItems: 'center' }}>
                  <Col>
                    <Text small bold color={publicaColors.black}>
                      Jira
                    </Text>
                  </Col>
                  <Col displayFlex>
                    <img
                      src='/assets/shared/svg/jira.svg'
                      style={{ width: '1.5em', height: '1.5em' }}
                    />
                  </Col>
                </Cols>
              </Button>
            </a>
          </Col>
        </Cols>
      </Col>
    </Cols>
  );
};
